
const retrieveData = [ 
    {
      name: 'Name of Student',
      email: '',
      title: 'Date of Birth',
      status: '',
      
    },
    {
      name: 'Gender',
      email: '',
      title: 'Class',
      status: '',
      
    },
    {
      name: 'Nationality',
      email: '',
      title: 'Religion',
      status: '',
  
    },
    {
      name: 'Mother Tongue',
      email: '',
      title: 'Birth Place',
      status: '',
    },
    {
      name: 'Aadhar Card No',
      email: ''	,
      title: 'Mode of Transport		',
      status: '',
    },

 
    //   {
    //   name: 'Does your child have any evidence of learning disablity?		',
    //   email: '',
    //   title: '',
    //   status: '',
    // },
    // {
    //   name: 'Gross Annual Income (INR)		',
    //   email: '1234'	,
    //   title: 'Gross Annual Income (INR)			',
    //   status: '1234',
    // },
  ];

  export default retrieveData;